import { PaperAirplaneIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'

export const ChatInput = ({
  vectorSearch,
  message,
  setMessage,
}: {
  vectorSearch: (messageContent: string) => Promise<void>
  message: string
  setMessage: (message: string) => void
}) => {
  const { chatbot } = useChatbotSettingsStore()
  const [disabled, setDisabled] = useState(false)
  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault()
        setMessage('')
        setDisabled(true)
        await vectorSearch(message)
        setDisabled(false)
      }}
    >
      <div className="relative my-2 flex items-center">
        <input
          type="text"
          name="search"
          id="search"
          value={message}
          disabled={disabled}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message here"
          className="block w-full rounded-md border-0 py-3 pr-14 text-gray-900 ring-0 placeholder:text-gray-400 focus:border-white focus:ring-0 focus:ring-white focus:ring-offset-0 focus:ring-offset-gray-100 sm:text-sm sm:leading-6"
        />
        <div
          className={`absolute inset-y-0 right-0 flex cursor-pointer pr-2.5 ${
            disabled ? 'cursor-not-allowed opacity-50' : ''
          }`}
          onClick={async (e) => {
            setDisabled(true)
            await vectorSearch(message)
            setDisabled(false)
          }}
        >
          <PaperAirplaneIcon
            className={'h-8 w-8'}
            style={{
              color: message ? chatbot?.theme_color || '#D1D5DB' : '#D1D5DB',
            }}
          />
        </div>
      </div>
    </form>
  )
}
